// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".details-wrapper[data-v-28cbfb12]{display:flex;flex-direction:row}.details-wrapper .double-column[data-v-28cbfb12],.details-wrapper .single-column[data-v-28cbfb12]{width:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
